import React, { useCallback, useEffect, useState, createContext } from "react";

const ToastContext = createContext();

export default ToastContext;

export function ToastContextProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const removeToast = toast => {
    var tmp = [...toasts]
    const index = toasts.map(item => item.id).indexOf(toast.id)
    if(index != -1){
      tmp.splice(index, 1)
      setToasts(tmp)
    }
  }

  const addToast = toast => {
    toast.id = new Date().getTime()
    setToasts([...toasts, toast])
  }

  useEffect(() => {
    if (toasts.length > 0) {
      const timer = setTimeout(
      () => setToasts(toasts => toasts.slice(1)), toasts[0].timeout ?? 15000);
      return () => clearTimeout(timer);
    }
  }, [toasts])

  return (
    <ToastContext.Provider value={addToast}>
      {children}

      {toasts.length > 0 &&
        <div className="p-3" style={{position: 'fixed', top: 0, right: 0, minWidth: '250px', maxHeight: '100%', overflow: 'hidden', zIndex: 1060}}>
          {toasts.map(toast => (
            <div className="toast fade show mb-2" key={toast.id} style={{opacity: 1}}>
              <div className={"toast-header bg-" + (toast.type ?? 'primary') + (!['warning'].includes(toast.type) ? ' text-white' : '')}>
                <strong className="me-auto">{toast.title ?? 'Title'}</strong>
                <button
                  type="button"
                  className={"btn-close"+ (!['warning'].includes(toast.type) ? ' btn-close-white' : '')}
                  aria-label="Close"
                  onClick={() => removeToast(toast)}
                ></button>
              </div>
              <div className="toast-body">
                {toast.message ?? 'Message'}
              </div>
            </div>
          ))}

        </div>
      }
    </ToastContext.Provider>
  );
}
